import moment from 'moment'

export const setEndOfTheDay = (date?: string) => {
  if (!date) {
    return
  }
  return moment(date).endOf('day').format()
}
